// FrontdeskContext.js
import { createContext } from 'react';

export const FrontDeskContext = createContext();